document.addEventListener("DOMContentLoaded", () =>{
  const completeLookButton = document.getElementById("btn-complete-look");
  const btnClose = document.querySelector(".complete-look-dialog #btn-close");
  const btnBack = document.querySelector(".ctn-product .btn-back");
  const completeLookDialog = document.querySelector(".section-complete");
  const subHeader = document.querySelector(".sub-header-products");
  const body = document.querySelector('body')
  const ctnProducts = document.querySelector(".ctn-products");
  const ctnProduct = document.querySelector(".ctn-product");
  const productItem = document.querySelectorAll(".ctn-product .product-look");
  const countElement = document.getElementById('count-items')
  countElement.textContent = productItem?.length

  completeLookButton?.addEventListener("click", function () {
    completeLookDialog.style.display = "block"
    body.style.overflow = "hidden"
  });
  
  window.addEventListener('resize', (e) => {
    if (window.innerWidth > 750) {
      completeLookDialog.style.display = "none"
      body.style.overflow = "scroll"
    }
  });

  // cerrar dialog
  btnClose?.addEventListener("click", function () {
    completeLookDialog.style.display = "none"
      body.style.overflow = "scroll"
  });
  btnBack?.addEventListener("click",  () =>{
    ctnProducts.style.display = "block";
    ctnProduct.style.display = "none";
    subHeader.style.display = "flex";
  })
  const ctnProductSlide = document.querySelectorAll('.complete-look-dialog .container-img')
  ctnProductSlide.forEach( item => {
    item.addEventListener("click", (e) => {
      ctnProducts.style.display = "none";
      ctnProduct.style.display = "block";
      subHeader.style.display = "none";

      productItem.forEach(itemProduct => {
        itemProduct.style.display = "none"
      })

      
      const element = e.target.closest('.swiper-slide')
      const elementIndex = element.getAttribute('data-product')
      const showProduct = ctnProduct.querySelector(`[data-product='${elementIndex}']`)
      const ctnMessageSuccess = document.querySelector('.complete-look-dialog .message-success')
      ctnMessageSuccess.style.display = "none"
      showProduct.style.display = "flex";
      const ctnMessageError = showProduct.querySelector('.ctn-message-error')
      const messageError = ctnMessageError.querySelector(' p')
      ctnMessageError.style.display = "none"
      //variants
      const variants = showProduct.querySelectorAll('.item-variant:not(.sold-out)')
      variants.forEach(variant => {
        variant.addEventListener("click", (e) => {
          variant.disabled = true
          const elementVariant = e.target
          const variantId = elementVariant.getAttribute('data-variant');
          elementVariant.classList.add('active')
          const data = [
            {
              id: variantId,
              quantity: 1
            }
          ]
          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: data,
                sections: 'cart-icon-bubble'
              })
            })
            .then(response => response.json())
            .then(data => {      
              if(data.status > 400){
                ctnMessageError.style.display = "flex"
                messageError.textContent = data.description
                return
              }
              const bubble = document.getElementById('cart-icon-bubble')
              const respProductName = document.querySelector('.resp-product-name')
              if(bubble) bubble.innerHTML = data.sections['cart-icon-bubble']
              ctnMessageError.style.display = "none"
              ctnProducts.style.display = "block";
              ctnProduct.style.display = "none";
              subHeader.style.display = "flex";
              ctnMessageSuccess.style.display = "flex"
              respProductName.textContent = `${data.items[0].untranslated_product_title} agregado a tu carrito.`

              // setTimeout(() =>{
              //   ctnMessageSuccess.style.display = "none"
              // }, 3000)
            })
            .catch(error => {
              console.log(error)            
            }).finally(() =>{
              variant.disabled = false
              elementVariant.classList.remove('active')
            })
        })
    })  
  })
})
})